<template>
  <div class="bgfff out_wrap">
    <div v-if="!emptyShow" class="mch-manage">
      <div class="scroll">
        <el-scrollbar class="scroll-box">
          <div v-for="item in mch_arr" :key="item.mch" :class="['mch-item', id === item.id ? 'active' : '']" @click="clickItem(item)">
            <div><span>{{ item.type == 1 ? '微信' : '支付宝' }}商户号：</span><span>{{ item.mch_id }}</span></div>
            <div class="mt10"><span>可用金额：</span><span>￥{{ $formatCurrency(item.balance) || '0.00' }}</span></div>
          </div>
        </el-scrollbar>
      </div>
      <div class="content">
        <div class="title">{{ type == 1 ? '微信' : '支付宝' }}商户号：{{ mch_id }}</div>
        <div v-if="type == 1" class="all-con mt20">
          <div class="fs16 bold">商户付款额度</div>
          <div class="mt20">
            <span>单日商户号付款上限：</span><span>{{ obj1.showValue }}元</span>
          </div>
          <ConfigInfo class="mt20" :show.sync="obj2.show" label="单笔付款区间" @save="saveRankMoney">
            <template v-if="obj2.show">
              <el-input v-model="obj2.min_pay" size="small" placeholder="请输入金额" />
              <span style="margin:0 10px;">~</span>
              <el-input v-model="obj2.max_pay" size="small" placeholder="请输入金额" />
            </template>
            <span v-if="!obj2.show">{{ obj2.showValue1 }}元<span style="margin:0 10px;">~</span>{{ obj2.showValue2 }}元</span>
            <template v-if="obj2.show" v-slot:tips>
              <span class="c9 ml10">提示：{{ `区间范围在${$formatCurrency(obj2.tips[0])}-${$formatCurrency(obj2.tips[1])}元。` }}</span>
            </template>
          </ConfigInfo>
          <div class="fs16 bold mt20">用户收款次数/额度</div>
          <ConfigInfo class="mt20" :show.sync="obj3.show" label="同一用户单日收款上限" @save="saveUserMoney">
            <el-input v-if="obj3.show" v-model="obj3.single_person_day_pay" size="small" placeholder="请输入金额" />
            <span v-if="!obj3.show">{{ obj3.showValue }}元</span>
            <template v-if="obj3.show" v-slot:tips>
              <span class="c9 ml10">提示：{{ `收款上限不高于${$formatCurrency(obj3.tips)}元。` }}</span>
            </template>
          </ConfigInfo>
          <ConfigInfo class="mt20" :show.sync="obj4.show" label="同一用户单日收款次数" @save="saveUserNum">
            <el-input v-if="obj4.show" v-model="obj4.single_person_day_num" size="small" placeholder="请输入次数" />
            <span v-if="!obj4.show">{{ obj4.showValue || 0 }}次</span>
            <template v-if="obj4.show" v-slot:tips>
              <span class="c9 ml10">提示：{{ `收款次数不高于${obj4.tips}次。` }}</span>
            </template>
          </ConfigInfo>
        </div>
        <div v-else class="all-con mt20">
          <div class="fs16 bold">单笔限额</div>
          <ConfigInfo class="mt20" :show.sync="obj2.show" label="单笔付款区间" @save="saveRankMoney">
            <template v-if="obj2.show">
              <el-input v-model="obj2.min_pay" size="small" placeholder="请输入金额" />
              <span style="margin:0 10px;">~</span>
              <el-input v-model="obj2.max_pay" size="small" placeholder="请输入金额" />
            </template>
            <span v-if="!obj2.show">{{ obj2.showValue1 }}元<span style="margin:0 10px;">~</span>{{ obj2.showValue2 }}元</span>
            <template v-if="obj2.show" v-slot:tips>
              <span class="c9 ml10">提示：{{ `区间范围在${$formatCurrency(obj2.tips[0])}-${$formatCurrency(obj2.tips[1])}元。` }}</span>
            </template>
          </ConfigInfo>
          <div class="fs16 bold mt20">日限额</div>
          <div class="mt20">
            <span>额度上限：</span><span>{{ obj1.showValue }}元</span>
          </div>
          <div class="fs16 bold mt20">月限额</div>
          <div class="mt20">
            <span>额度上限：</span><span>{{ obj.showValue }}元</span>
          </div>
          <div class="fs16 bold mt20">用户收款次数/额度</div>
          <ConfigInfo class="mt20" :show.sync="obj3.show" label="同一用户单日收款上限" @save="saveUserMoney">
            <el-input v-if="obj3.show" v-model="obj3.single_person_day_pay" size="small" placeholder="请输入金额" />
            <span v-if="!obj3.show">{{ obj3.showValue }}元</span>
            <template v-if="obj3.show" v-slot:tips>
              <span class="c9 ml10">提示：{{ `收款上限不高于${$formatCurrency(obj3.tips)}元。` }}</span>
            </template>
          </ConfigInfo>
          <ConfigInfo class="mt20" :show.sync="obj4.show" label="同一用户单日收款次数" @save="saveUserNum">
            <el-input v-if="obj4.show" v-model="obj4.single_person_day_num" size="small" placeholder="请输入次数" />
            <span v-if="!obj4.show">{{ obj4.showValue || 0 }}次</span>
            <template v-if="obj4.show" v-slot:tips>
              <span class="c9 ml10">提示：{{ `收款次数不高于${obj4.tips}次。` }}</span>
            </template>
          </ConfigInfo>
        </div>
      </div>
    </div>
    <div v-else class="empty">
      <div style="width: 200px;">
        <svg viewBox="0 0 79 86" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><linearGradient id="linearGradient-1-2" x1="38.8503086%" y1="0%" x2="61.1496914%" y2="100%"><stop stop-color="#FCFCFD" offset="0%" /><stop stop-color="#EEEFF3" offset="100%" /></linearGradient><linearGradient id="linearGradient-2-2" x1="0%" y1="9.5%" x2="100%" y2="90.5%"><stop stop-color="#FCFCFD" offset="0%" /><stop stop-color="#E9EBEF" offset="100%" /></linearGradient><rect id="path-3-2" x="0" y="0" width="17" height="36" /></defs><g id="Illustrations" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="B-type" transform="translate(-1268.000000, -535.000000)"><g id="Group-2" transform="translate(1268.000000, 535.000000)"><path id="Oval-Copy-2" d="M39.5,86 C61.3152476,86 79,83.9106622 79,81.3333333 C79,78.7560045 57.3152476,78 35.5,78 C13.6847524,78 0,78.7560045 0,81.3333333 C0,83.9106622 17.6847524,86 39.5,86 Z" fill="#F7F8FC" /><polygon id="Rectangle-Copy-14" fill="#E5E7E9" transform="translate(27.500000, 51.500000) scale(1, -1) translate(-27.500000, -51.500000) " points="13 58 53 58 42 45 2 45" /><g id="Group-Copy" transform="translate(34.500000, 31.500000) scale(-1, 1) rotate(-25.000000) translate(-34.500000, -31.500000) translate(7.000000, 10.000000)"><polygon id="Rectangle-Copy-10" fill="#E5E7E9" transform="translate(11.500000, 5.000000) scale(1, -1) translate(-11.500000, -5.000000) " points="2.84078316e-14 3 18 3 23 7 5 7" /><polygon id="Rectangle-Copy-11" fill="#EDEEF2" points="-3.69149156e-15 7 38 7 38 43 -3.69149156e-15 43" /><rect id="Rectangle-Copy-12" fill="url(#linearGradient-1-2)" transform="translate(46.500000, 25.000000) scale(-1, 1) translate(-46.500000, -25.000000) " x="38" y="7" width="17" height="36" /><polygon id="Rectangle-Copy-13" fill="#F8F9FB" transform="translate(39.500000, 3.500000) scale(-1, 1) translate(-39.500000, -3.500000) " points="24 7 41 7 55 -3.63806207e-12 38 -3.63806207e-12" /></g><rect id="Rectangle-Copy-15" fill="url(#linearGradient-2-2)" x="13" y="45" width="40" height="36" /><g id="Rectangle-Copy-17" transform="translate(53.000000, 45.000000)"><mask id="mask-4-2" fill="white"><use xlink:href="#path-3-2" /></mask><use id="Mask" fill="#E0E3E9" transform="translate(8.500000, 18.000000) scale(-1, 1) translate(-8.500000, -18.000000) " xlink:href="#path-3-2" /><polygon id="Rectangle-Copy" fill="#D5D7DE" mask="url(#mask-4-2)" transform="translate(12.000000, 9.000000) scale(-1, 1) translate(-12.000000, -9.000000) " points="7 0 24 0 20 18 -1.70530257e-13 16" /></g><polygon id="Rectangle-Copy-18" fill="#F8F9FB" transform="translate(66.000000, 51.500000) scale(-1, 1) translate(-66.000000, -51.500000) " points="62 45 79 45 70 58 53 58" /></g></g></g></svg>
      </div>
      <div class="mt20 fs16">
        暂无商户号，请联系平台方处理
      </div>
    </div>
  </div>
</template>

<script>
import { mchAll } from '@/api/mch'
import { mchInfo, mchRangeConfig, mchDayPayConfig, mchDayNumConfig } from '@/api/mch'
import { validateMoneyFunc } from '@/utils/fn'
import { get } from '@/utils/storage'
import ConfigInfo from './components/ConfigInfo.vue'
export default {
  components: {
    ConfigInfo
  },
  data() {
    return {
      mch_arr: [],
      company_id: JSON.parse(get('userinfo')).company_id || '',
      mch_id: '',
      id: '',
      type: '',
      // 单月商户号付款上限
      obj: {
        show: false,
        top_pay: '',
        showValue: '',
        tips: ''
      },
      // 单日商户号付款上限
      obj1: {
        show: false,
        top_pay: '',
        showValue: '',
        tips: ''
      },
      // 单笔付款区间
      obj2: {
        show: false,
        min_pay: '',
        max_pay: '',
        showValue1: '',
        showValue2: '',
        tips: []
      },
      // 同一用户单日收款上限
      obj3: {
        show: false,
        single_person_day_pay: '',
        showValue: '',
        tips: ''
      },
      // 同一用户单日收款次数
      obj4: {
        show: false,
        single_person_day_num: '',
        showValue: '',
        tips: ''
      },
      emptyShow: false
    }
  },
  async mounted() {
    const res = await mchAll({ company_id: this.company_id })
    if (res.code === 200) {
      this.mch_arr = res.data
      // 默认值
      if (this.mch_arr.length) {
        this.emptyShow = false
        this.id = res.data[0].id
        this.mch_id = res.data[0].mch_id
        this.type = res.data[0].type
        this.query()
      } else {
        this.emptyShow = true
      }
    }
  },
  methods: {
    async query() {
      const res = await mchInfo({ mch_id: this.mch_id, id: this.id, type: this.type })
      if (res.code === 200) {
        // 单月商户号付款上限
        this.obj.top_pay = Number(res.data.company_mch_info.month_top_pay) / 100
        this.obj.showValue = this.$formatCurrency(res.data.company_mch_info.month_top_pay)
        this.obj.tips = res.data.mch_info.month_top_pay
        // 单日商户号付款上限
        this.obj1.top_pay = Number(res.data.company_mch_info.top_pay) / 100
        this.obj1.showValue = this.$formatCurrency(res.data.company_mch_info.top_pay)
        this.obj1.tips = res.data.mch_info.top_pay
        // 单笔付款区间
        this.obj2.min_pay = Number(res.data.company_mch_info.min_pay) / 100
        this.obj2.max_pay = Number(res.data.company_mch_info.max_pay) / 100
        this.obj2.showValue1 = this.$formatCurrency(res.data.company_mch_info.min_pay)
        this.obj2.showValue2 = this.$formatCurrency(res.data.company_mch_info.max_pay)
        this.obj2.tips = [res.data.mch_info.min_pay, res.data.mch_info.max_pay]
        // 同一用户单日收款上限
        this.obj3.single_person_day_pay = Number(res.data.company_mch_info.single_person_day_pay) / 100
        this.obj3.showValue = this.$formatCurrency(res.data.company_mch_info.single_person_day_pay)
        this.obj3.tips = res.data.mch_info.single_person_day_pay
        // 同一用户单日收款次数
        this.obj4.single_person_day_num = res.data.company_mch_info.single_person_day_num
        this.obj4.showValue = res.data.company_mch_info.single_person_day_num
        this.obj4.tips = res.data.mch_info.single_person_day_num
      }
    },
    saveRankMoney() {
      if (!this.obj2.min_pay) {
        this.$message.error('请输入区间开始值')
        return
      }
      if (+this.obj2.min_pay <= 0) {
        this.$message.error('请输入大于零的值')
        return
      }
      if (!this.obj2.max_pay) {
        this.$message.error('请输入区间结束值')
        return
      }
      if (+this.obj2.max_pay <= 0) {
        this.$message.error('请输入大于零的值')
        return
      }
      if (!validateMoneyFunc(this.obj2.min_pay)) {
        this.$message.error('请输入正确金额格式,可保留两位小数')
        return
      }
      if (!validateMoneyFunc(this.obj2.max_pay)) {
        this.$message.error('请输入正确金额格式,可保留两位小数')
        return
      }
      if (+this.obj2.min_pay >= +this.obj2.max_pay) {
        this.$message.error('结束值必须大于开始值')
        return
      }
      if (+this.obj2.min_pay < (+this.obj2.tips[0] / 100) || +this.obj2.max_pay > (+this.obj2.tips[1] / 100)) {
        this.$message.error(`区间范围在${this.obj2.tips[0] / 100}-${this.obj2.tips[1] / 100}元。`)
        return
      }
      mchRangeConfig({ mch_id: this.mch_id, min_pay: this.obj2.min_pay, max_pay: this.obj2.max_pay, id: this.id, type: this.type }).then(res => {
        if (res.code === 200) {
          this.$message.success('配置成功!')
          this.query()
          this.obj2.show = false
        }
      })
    },
    saveUserMoney() {
      if (!this.obj3.single_person_day_pay) {
        this.$message.error('请输入单日商户号收款上限金额')
        return
      }
      if (+this.obj3.single_person_day_pay <= 0) {
        this.$message.error('请输入大于零的值')
        return
      }
      if (!validateMoneyFunc(this.obj3.single_person_day_pay)) {
        this.$message.error('请输入正确金额格式,可保留两位小数')
        return
      }
      if (+this.obj3.single_person_day_pay > (+this.obj3.tips / 100)) {
        this.$message.error(`收款上限不高于${this.obj3.tips / 100}元。`)
        return
      }
      mchDayPayConfig({ mch_id: this.mch_id, single_person_day_pay: this.obj3.single_person_day_pay, id: this.id, type: this.type }).then(res => {
        if (res.code === 200) {
          this.$message.success('配置成功!')
          this.query()
          this.obj3.show = false
        }
      })
    },
    saveUserNum() {
      if (!this.obj4.single_person_day_num) {
        this.$message.error('请输入单日商户号收款次数')
        return
      }
      if (+this.obj4.single_person_day_num <= 0) {
        this.$message.error('请输入大于零的值')
        return
      }
      if (!/^[+]{0,1}(\d+)$/.test(this.obj4.single_person_day_num)) {
        this.$message.error('请输入正整数')
        return
      }
      if (this.obj4.single_person_day_num > this.obj4.tips) {
        this.$message.error(`收款次数不高于${this.obj4.tips}次。`)
        return
      }
      mchDayNumConfig({ mch_id: this.mch_id, single_person_day_num: this.obj4.single_person_day_num, id: this.id, type: this.type }).then(res => {
        if (res.code === 200) {
          this.$message.success('配置成功!')
          this.query()
          this.obj4.show = false
        }
      })
    },
    clickItem(item) {
      if (this.id === item.id) return
      this.obj.show = false
      this.obj1.show = false
      this.obj2.show = false
      this.obj3.show = false
      this.obj4.show = false
      this.mch_id = item.mch_id
      this.id = item.id
      this.type = item.type
      this.query()
    }
  }
}
</script>

<style lang="scss" scoped>
.box-card{
  margin-right: 20px;
  margin-bottom: 20px;
  width: 250px;
  cursor: pointer;
  &:last-child{
    margin-right: 0;
  }
  &.active{
    border: 1px solid #409EFF;
  }
}
.mch-manage{
  display: flex;
  flex-direction: row;
  .scroll{
    width: 250px;
    height: 100%;
    overflow-y: auto;
    .scroll-box{
      height: calc(100vh - 130px);
    }
    .mch-item{
      border-radius: 2px;
      border: 1px solid #E9E9E9;
      padding: 10px 32px;
      box-sizing: border-box;
      margin-bottom: 20px;
      cursor: pointer;
      color: #000;
      position: relative;
      &:last-child{
        margin-bottom: 0;
      }
      &.active{
        color: #1890FF;
        border: none;
        background: rgba(24,144,255, 0.06);
        &::before{
          content: '';
          position: absolute;
          width: 3px;
          height: 28px;
          background: #1890FF;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
        }
      }
    }
  }
  .content{
    flex: 1;
    padding-left: 40px;
    box-sizing: border-box;
    .title{
      font-size: 16px;
      color: #1890FF;
    }
    .all-con{
      border-radius: 2px;
      border: 1px solid #EEEEEE;
      padding: 20px;
      box-sizing: border-box;
    }
  }
}
::v-deep{
  .config_item {
    .el-input{
      width: 180px;
    }
  }
  .el-scrollbar__wrap{
    overflow-x: hidden;
  }
}
.empty{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-align: center;
    box-sizing: border-box;
    padding: 40px 0;
    width: 100%;
}
</style>
